import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { HttpClient } from '../configs/axios.config';
import { LegModel } from '../interfaces/models/LegModel';
import { MilestoneModel } from '../interfaces/models/MilestoneModel';
import { Api } from './Api';

export interface CurrentProgressResponse {
    // learned_legs: number,
    // total_legs: number,
    offset: number;
    current_position: number;
    next_position: number;
    average_cards: number;
    leg: LegModel,
    milestone?: MilestoneModel
}

export interface ProgressBarResponse {
    answers: number;
    answers_today: number;
    answers_days: number;
    achievement?: {
        id: number;
        description: string;
    }
}

@injectable()
export class ProgressApi implements Api {

    constructor(
        public api: HttpClient
    ) {}

    getCurrent(courseId: number): AxiosPromise<CurrentProgressResponse> {
        return this.api.client.get<CurrentProgressResponse>(`/progress/current/?course=${courseId}`);
    }

    getProgressBar(courseId: number): AxiosPromise<ProgressBarResponse> {
        return this.api.client.get<ProgressBarResponse>(`/progress/bar/?course=${courseId}`);
    }

}
